// devLog — logs silenciados en producción para no exponer estado de sesión / errores internos
// al devtools del usuario final. En desarrollo delega a console.

const isDev = process.env.NODE_ENV !== 'production';

export const devWarn = (...args) => { if (isDev) console.warn(...args); };
export const devError = (...args) => { if (isDev) console.error(...args); };
export const devLog = (...args) => { if (isDev) console.log(...args); };
